module.exports = __webpack_public_path__ + "static/media/alert-triangle.943cceb1.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/Icons/alert-triangle.svg
// module id = 830
// module chunks = 21